'use strict';

angular.module('aq.admin.productDesign').controller('EmailCtrl',
    function ($scope, $state) {


});